import React, { useState, useEffect } from 'react';
import { useTags } from '../../hooks/useTags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface TagsModalProps {
  file: any;
  onClose: () => void;
  onSuccess: () => void;
}

const TagsModal: React.FC<TagsModalProps> = ({ file, onClose, onSuccess }) => {
  const [newTag, setNewTag] = useState('');
  const [fileTags, setFileTags] = useState<string[]>(file.tags || []);
  const { addTagsToFile, removeTagFromFile, loading } = useTags();

  const handleAddTag = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!newTag.trim() || fileTags.includes(newTag.trim().toLowerCase())) {
      return;
    }

    const result = await addTagsToFile(file.id, [newTag.trim().toLowerCase()]);
    if (result) {
      setFileTags([...fileTags, newTag.trim().toLowerCase()]);
      setNewTag('');
    }
  };

  const handleRemoveTag = async (tag: string) => {
    const result = await removeTagFromFile(file.id, tag);
    if (result) {
      setFileTags(fileTags.filter(t => t !== tag));
    }
  };

  const handleDone = () => {
    onSuccess();
    onClose();
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Manage Tags</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>
              Tags for{' '}
              <strong 
                style={{ 
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  hyphens: 'auto'
                }}
                title={file.name}
              >
                {file.name}
              </strong>
            </p>
            
            <div className="mb-3">
              {fileTags.length > 0 ? (
                <div>
                  {fileTags.map((tag) => (
                    <span key={tag} className="badge badge-secondary mr-2 mb-2" style={{ fontSize: '14px' }}>
                      {tag}
                      <button
                        className="btn btn-sm btn-link text-white p-0 ml-2"
                        onClick={() => handleRemoveTag(tag)}
                        disabled={loading}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </span>
                  ))}
                </div>
              ) : (
                <p className="text-muted">No tags yet</p>
              )}
            </div>

            <form onSubmit={handleAddTag}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                  placeholder="Add a tag..."
                  disabled={loading}
                />
                <div className="input-group-append">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading || !newTag.trim()}
                  >
                    Add
                  </button>
                </div>
              </div>
              <small className="text-muted">
                Tags must be alphanumeric, max 50 characters
              </small>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={handleDone}>
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagsModal;
